// extracted by mini-css-extract-plugin
export default {"container":"privacy_container__ppfFn","title":"privacy_title__cSidu","img":"privacy_img__QnI-X"};